export enum IssueType {
  UNKNOWN = 'UNKNOWN',
  NOT_FOUND = 'NOT_FOUND',
  BENEFIT_PAGE_ERROR = 'BENEFIT_PAGE_ERROR',
}
